var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(false)?_c('section',{attrs:{"id":"app-loading"}},[_c('img',{attrs:{"src":require("@/assets/images/logo_hotel_voucher.png"),"alt":"logo"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }